module.exports = "/* .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-list-item-selected {}\r\n */\r\n .btn-marron {\r\n    margin-right: 25px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dashboard/documents/documents.component.css
// module id = ./src/app/modules/dashboard/dashboard/documents/documents.component.css
// module chunks = dashboard.module